import i18n from '../../../i18n';

const getDefaultState = () => ({
  items: [
    {
      subheading: i18n.t('menu.general.title'),
      pages: [
        {
          title: i18n.t('menu.general.pages.dashboard.title'),
          to: { name: 'Index' },
          icon: 'ballot',
          exact: true,
        },
        {
          title: i18n.t('menu.general.pages.twenty.title'),
          href: process.env.TWENTY_FRONT_PAGE,
          icon: 'launch',
          exact: false,
        },
      ],
    },
    {
      subheading: i18n.t('menu.nonDynamicTransport.title'),
      pages: [
        {
          title: i18n.t('menu.nonDynamicTransport.pages.overview.title'),
          to: { name: 'NonDynamicTransportOverview' },
          icon: 'view_list',
          exact: false,
        },
      ],
    },
    {
      subheading: i18n.t('menu.transportation.title'),
      pages: [
        {
          title: i18n.t('menu.transportation.pages.overview.title'),
          to: { name: 'overview' },
          icon: 'directions_boat',
          exact: false,
        },
      ],
    },
    {
      subheading: i18n.t('menu.itinerary.title'),
      pages: [
        {
          title: i18n.t('menu.itinerary.pages.overview.title'),
          to: { name: 'ItineraryOverview' },
          icon: 'directions_walk',
          exact: false,
        },
      ],
    },
    {
      subheading: i18n.t('menu.ski.title'),
      pages: [
        {
          title: i18n.t('menu.ski.pages.areas.title'),
          to: { name: 'SkiAreas' },
          icon: 'filter_hdr',
        },
        {
          title: i18n.t('menu.ski.pages.skistar.title'),
          to: { name: 'Skistar' },
          icon: 'launch',
          exact: false,
        },
        {
          title: 'Restech',
          to: { name: 'Restech' },
          icon: 'launch',
          exact: false,
        },
        {
          title: 'VisitGroup',
          to: { name: 'VisitGroup' },
          icon: 'launch',
          exact: false,
        },
        {
          title: i18n.t('menu.ski.pages.skiPass.title'),
          to: { name: 'SkiPassSeasons' },
          icon: 'style',
          exact: false,
        },
        {
          title: i18n.t('menu.ski.pages.skiSchool.title'),
          to: { name: 'SkiSchoolSeasons' },
          icon: 'store',
          exact: false,
        },
        {
          title: i18n.t('menu.ski.pages.skiRental.title'),
          to: { name: 'SkiRentalSeasons' },
          icon: 'business_center',
          exact: false,
        },
      ],
    },
  ],
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/nav/defaultState.js